import { Description, ExtensionRounded, Headphones, Videocam } from "@mui/icons-material";
import { capitalize, Card, Divider, Grid, Icon } from "@mui/material";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { ContentType } from "models/content/Content";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getContentStats } from "utils/contentUtils";
import { groupBy } from "utils/globalsUtils";

const MDTypography = require("components/MDTypography").default;

export const ContentTypes = () => {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { currentBrand } = controller;
  const [stats, setStats] = useState([] as any);

  useEffect(() => {
    getContentStats().then((stats) => setStats(groupBy(stats, (x) => x.type)));
  }, [currentBrand]);

  const types = [
    {
      type: ContentType.article,
      label: "Articles",
      items: 0,
      icon: <Description />,
    },
    {
      type: ContentType.video,
      label: "Video",
      items: 0,
      icon: <Videocam />,
    },
    {
      type: ContentType.audio,
      label: "Audio",
      items: 0,
      icon: <Headphones />,
    },
    {
      type: ContentType.link,
      label: "External content",
      items: 0,
      icon: <ExtensionRounded />,
    },
  ];

  const typeTile = (type) => {
    const itemsCount = stats[type.type]?.reduce((acc, item) => acc + parseInt(item.count), 0);
    const categoriesCount = stats[type.type]?.length;
    return (
      <Card
        sx={{
          width: 280,
          height: 280,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => navigate(`/contentsCenter/${type.type}`)}
      >
        <Grid container direction="column" alignItems="center" gap={2}>
          <Icon
            fontSize="large"
            sx={{
              color: "primary.main",
            }}
          >
            {type.icon}
          </Icon>
          <MDTypography item>{capitalize(type.label)}</MDTypography>
          <MDTypography variant="body2" fontWeight="bold">
            {itemsCount || "0"} items | {categoriesCount || "0"} categories
          </MDTypography>
        </Grid>
      </Card>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Content Center" />
      <Grid container gap={2}>
        {types.map((type) => (
          <Grid>{typeTile(type)}</Grid>
        ))}
      </Grid>
    </DashboardLayout>
  );
};
